import React from 'react'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import { useFormContext } from 'react-hook-form'
import FormSubheader from '../form-subheader'
import { getFieldProps, useCreateProfileFieldStyles } from '../field-styles'

const VideoIntroductionField = () => {
  const fieldClasses = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(fieldClasses)
  const { errors, register } = useFormContext()

  return (
    <Box className={fieldClasses.fieldSection}>
      <FormSubheader
        title="Video introduction"
        description="Add a YouTube link to a brief video introducing yourself and your coaching philosophy. We do not support YouTube Shorts at this time."
      />
      <TextField
        {...fieldProps}
        name="introductionVideoUrl"
        label="YouTube"
        type="text"
        inputRef={register()}
        placeholder="https://www.youtube.com/watch?v=AMozaT8GCFg"
        error={!!errors.introductionVideoUrl}
        helperText={errors.introductionVideoUrl?.message}
      />
    </Box>
  )
}

export default VideoIntroductionField
